import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PatientChatComponent } from "../../patients-list/patient-profile/patient-chat/patient-chat.component";
import { ConversationModel } from 'src/app/models/conversation-model';
import { ClinicPatientService } from 'src/app/services/clinic.patient.service';
import { ClinicCalendarService } from 'src/app/services/clinic-calendar.service';
import { ToastHelper } from '../toaster.helper';
import { ChatService } from 'src/app/services/chat.service';
import { ActivatedRoute } from '@angular/router';
import { PatientProfilingService } from '../../patients-list/patient-profile/patient-profiling.service';
import { CurrentProfileData } from '../../patients-list/patient-profile/patient-profile.component';
import { isValueNullOrEmpty } from 'src/app/utilities/validation.utils';
import { firstValueFrom, Subject, take, takeUntil } from 'rxjs';
import store from 'store2';
import { SpinnerComponent } from "../spinner/spinner.component";

@Component({
  selector: 'app-chat-float',
  imports: [CommonModule, FormsModule, PatientChatComponent, SpinnerComponent],
  templateUrl: './chat-float.component.html',
  styleUrl: './chat-float.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatFloatComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @Input() PatientID: number;// = 114063;
  @Input() styleString: string;
  loading: boolean;
  patient: any;
  conversationModel = new ConversationModel();
  receivedMessages: string[] = [];
  enableFeature: boolean = false;
  messageToSend: string = '';
  patientName: string = "Patient";
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;
  @Output() removeChat = new EventEmitter<number>();

  FeatureCode: string = 'TwoWayTextFeature';
  activeUser: conversationUser = new conversationUser();
  users: conversationUser[] = [];
  messageReceivedFrom = {
    img: '',
    name: 'Support'
  };

  isOpen = false;

  toggleChat() {
    this.isOpen = !this.isOpen;
  }

  constructor(private _clinicPatientService: ClinicPatientService,
    private _clinicCalendarService: ClinicCalendarService, private _toastr: ToastHelper,
    private _chatService: ChatService,
    private _route: ActivatedRoute,
    private _profileService: PatientProfilingService,
    private cdr: ChangeDetectorRef) { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  currentData: CurrentProfileData = new CurrentProfileData();
  ngOnInit(): void {
    let profileId: number = 0;
    if (isValueNullOrEmpty(this.PatientID)) {
      if (isValueNullOrEmpty(this._route.snapshot.params['patientId'])) {
        //this.currentData = store('currentProfileInfo');

        this._profileService.currentProfileInfo$.pipe(takeUntil(this.destroy$)).subscribe(data => {
          this.currentData = data;
          this.cdr.markForCheck();
        });

        profileId = this.currentData.profileId;
      } else {
        profileId = this._route.snapshot.params['patientId'];
        this.currentData.profileId = this._route.snapshot.params['patientId'];
        this.currentData.address = '';
        this.currentData.contactNo = '';
        this.currentData.countryName = '';
        this.currentData.firstName = '';
        this.currentData.lastName = '';
        this._profileService.updateProfileInfo(this.currentData);
        // store('currentProfileInfo', this.currentData);
      }
    } else {
      profileId = this.PatientID;
    }
    this.loading = true;
    this.getPatientById(profileId)
      .then((data: any) => {
        this.patientName = `${this.patient.lastName}, ${this.patient.firstName}`;
        this.setUserActive(new conversationUser(
          this.patient.lastName + ", " + this.patient.firstName,
          "",
          []
        ));
        this._chatService.getConversationMessages(this.conversationModel).pipe(take(1)).subscribe(
          (res: any) => {
            if (res != null) {
              res.forEach(element => {
                if (element.author == "system") {
                  this.activeUser.messages.push({ type: 'sent', message: element.body, date: element.date_created })
                }
                else {
                  this.activeUser.messages.push({ type: 'replies', message: element.body, date: element.date_created })
                }
              });
              this.activeUser.messages.sort((b, a) => new Date(b.date).getTime() - new Date(a.date).getTime());
              setTimeout(() => this.scrollToBottom(), 150);
            }
            this.loading = false;
            this.cdr.markForCheck();
          },
          err => {
            this.loading = false;
            this.cdr.markForCheck();
          });

      })
      .catch(error => {
        this.loading = false;
        this.cdr.markForCheck();
      });
    this.checkAllowedFeature();
  }

  private scrollToBottom(): void {
    try {
      const container = this.scrollContainer.nativeElement;
      container.scrollTop = container.scrollHeight;
    } catch (err) {
      console.error('Could not scroll to bottom:', err);
    }
  }

  setUserActive(user): void {
    this.activeUser = user;
  }

  async getPatientById(patientID: number): Promise<any> {
    try {
      const res: any = await firstValueFrom(
        this._clinicPatientService.GetPatientById(patientID).pipe(take(1))
      );
      if (res != null || res != undefined) {
        this.patient = res;
        this.conversationModel.patientId = this.patient.patientID;
      }
      //this.sendMessageWb();
      return res;
    } catch (err) {
      throw new Error('Error, GetPatientById');
    }
  }

  async sendFeatureRequest(): Promise<void> {
    try {
      const res: any = await firstValueFrom(
        this._clinicCalendarService.SendRequestToUseFeature(parseInt(store('userBranches')), this.FeatureCode).pipe(take(1))
      );
      console.log("Pay Result", res);
      this._toastr.showInfo('Our team will be in touch with you shortly. Thank you');
    } catch (err) {
      this._toastr.showError('Our team will be in touch with you shortly. Thank you!');
    }
  }
  addNewMessage() {
    if (this.messageToSend) {
      if (this.activeUser.messages.length == 0) {
        this.createConversationAndSendMessage(this.messageToSend);
      }
      else {
        this.conversationModel.messageBody = this.messageToSend
        this._chatService.sendMessageTwilio(this.conversationModel).pipe(take(1)).subscribe(
          {
            next: (res: any) => {
              this.activeUser.messages.push({ type: 'sent', message: this.messageToSend, date: new Date() });
              this.messageToSend = "";
              setTimeout(() => this.scrollToBottom(), 100);
              this.cdr.markForCheck();
            },
            error: err => {
            }
          });
      }
    }
  }

  createConversationAndSendMessage(val) {
    this._chatService.createConversation(this.conversationModel).pipe(take(1)).subscribe(
      {
        next: (res: any) => {
          this.conversationModel.messageBody = val
          this._chatService.sendMessageTwilio(this.conversationModel).pipe(take(1)).subscribe(
            {
              next: (res: any) => {
                this.activeUser.messages.push({ type: 'sent', message: val, date: new Date() });
                this.cdr.markForCheck();
              },
              error: err => {
              }
            });
        },
        error: err => {
        }
      });
  }
  checkAllowedFeature() {
    this._clinicCalendarService.CheckAllowedFeature(store('userBranches'), this.FeatureCode).pipe(take(1)).subscribe({
      next: (res: any) => {
        this.enableFeature = res;
        this.cdr.markForCheck();
      },
      error: err => {
        this.enableFeature = false;
        this.cdr.markForCheck();
      }
    });
  }

  onChatClose(): void {
    // this._toastr.showInfo("Chat CLosed!");
    this.removeChat.emit(this.PatientID);
  }

  trackByIndex(index: number): number { return index; }
}

export class Message {
  constructor(public type: "sent" | "replies", public message: string, public date: Date) { }
}

export class conversationUser {
  id = Math.random();
  constructor(
    public name: string = "",
    public img: string = "",
    public messages: Message[] = []
  ) { }
}